import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Button, Link as ChakraLink } from "@chakra-ui/react";
import { FunctionComponent, ReactElement } from "react";
import { Link } from "react-router-dom";

export type LinkableTableCellProps = {
	To: string;
	Contents: string | number | ReactElement;
	IsExternal?: boolean;
};

/**
 * Simple component to render a custom anchor similar in design to
 * <LapDataTable />'s linkable={true}
 * @param props
 * To: The relative url to which the user is routed
 *
 * Contents: The contents to be displayed within the anchor
 * @returns ReactElement
 */
const LinkableTableCell: FunctionComponent<LinkableTableCellProps> = (props: LinkableTableCellProps): ReactElement => {
	const { To, Contents, IsExternal = false } = props;

	return IsExternal ? (
		<Button
			as={ChakraLink}
			size="sm"
			color={"orange.600"}
			style={{ background: "transparent" }}
			_hover={{ textDecoration: "underline" }}
			target="_blank"
			href={To}
			isExternal={IsExternal}>
			{Contents}&nbsp;
			<ExternalLinkIcon mx="2px" mb="2px" />
		</Button>
	) : (
		<ChakraLink
			as={Link}
			variant="ghost"
			size="sm"
			fontWeight={500}
			color={"orange.600"}
			style={{ background: "transparent" }}
			_hover={{ textDecoration: "underline" }}
			to={To}
			// eslint-disable-next-line no-restricted-globals
			state={{ from: location.pathname + location.search }}>
			{Contents}
		</ChakraLink>
	);
};

export default LinkableTableCell;
